import React from 'react'

/**
 * Texto invisível (LRM + espaço) usado para reservar a linha de helperText,
 * mantendo o select alinhado com os outros campos do formulário.
 */
export const HELPER_TEXT_FORM = '\u200e '

export type SelectProps = {
    size?: 'small' | 'medium' | undefined
    helperText?: string
    form?: boolean
    isSupervisor?: boolean
    defaultValue?: number
    children?: React.ReactNode
    button?: boolean
    disabled?: boolean
    width?: string | number
    variant?: 'outlined' | 'filled' | 'standard'
    /** Classe do elemento raiz do select. */
    className?: string
    /**
     * Esconde o select quando não há o que escolher: nenhuma opção em
     * `SelectCentroCusto` e `SelectLocais` (#1925), no máximo uma em
     * `SelectEmpresa` e `SelectEmpresas`.
     */
    hideWhenSingle?: boolean
}
